<div class="container fw-b">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>
</div>

<section class="search-page">
  <div class="search-page__container">

    <div class="filters-row">
      <!-- Category Filter -->
      <div class="filter-card filter-card--category">
        <div class="filter-title">CATEGORY: </div>
        <select
          class="category-select"
          (change)="onCategoryFilterChange($event.target.value)"
        >
          <option value="">All</option>
          <option
            *ngFor="let cat of categoryListArray"
            [value]="cat?._id"
          >
            {{ cat?.categoryName }}
          </option>
        </select>
      </div>

      <!-- Price Range Filter -->
      <div class="filter-card filter-card--price">
        <div class="filter-title">PRICE RANGE: </div>
        <div class="price-slider">
          <input
            type="range"
            class="price-range"
            [min]="priceMin"
            [max]="priceMax"
            [(ngModel)]="selectedMaxPrice"
            (input)="onPriceRangeChange()"
          />
          <div class="price-range-label">
            ₹{{ priceMin }} - ₹{{ selectedMaxPrice }}+
          </div>
        </div>
      </div>

      <!-- Discount / Deal Filter -->
      <div class="filter-card filter-card--discount">
        <div class="filter-title">DISCOUNT RANGE: </div>
        <select
          class="discount-select"
          [(ngModel)]="selectedMinDiscount"
          (change)="onDiscountChange()"
        >
          <option [ngValue]="null">All</option>
          <option
            *ngFor="let d of discountOptions"
            [ngValue]="d.value"
          >
            {{ d.label }}
          </option>
        </select>
      </div>
    </div>

    <div class="product-grid" *ngIf="categoryListArrayNew?.length">
        <ng-container *ngFor="let item of categoryListArrayNew | paginate:{ itemsPerPage: itemPerPage, currentPage: currentPage, totalItems: totalItems }">
        <article
          class="product-card"
          role="button"
          (click)="forID(item?._id)"
          (mouseenter)="startImageCarousel(item)"
          (mouseleave)="stopImageCarousel(item)"
        >
          <div class="product-card__thumb">
            <img
              class="product-card__image"
              [src]="getActiveImage(item)"
              alt="{{ item?.productName || 'Product image' }}"
            />

            <div
              class="product-card__dots"
              *ngIf="getImageList(item)?.length > 1"
            >
              <span
                class="product-card__dot"
                *ngFor="let img of getImageList(item); let i = index"
                [class.active]="getCarouselIndex(item) === i"
              ></span>
            </div>

            <button
              type="button"
              class="product-card__wishlist"
              (click)="toggleWishlist(item?._id, $event)"
              [class.active]="item?.isLike"
            >
              <i class="fa" [ngClass]="item?.isLike ? 'fa-heart' : 'fa-heart-o'" aria-hidden="true"></i>
            </button>

            <span class="product-card__badge" *ngIf="item?.isNew">New</span>
            <span class="product-card__badge product-card__badge--ad" *ngIf="item?.isAd">AD</span>
          </div>

          <div class="product-card__body">
            <div class="product-card__rating" *ngIf="item?.rating || item?.ratingCount">
              <i class="fa fa-star" aria-hidden="true"></i>
              <span>{{ item?.rating || '4.2' }} | {{ item?.ratingCount || '1k+' }}</span>
                </div>

            <h3 class="product-card__brand">{{ item?.brandName || item?.productName || '--' }}</h3>
            <p class="product-card__name">{{ item?.categoryId?.categoryName || item?.productName || '--' }}</p>

            <div class="product-card__price">
              <!-- Original price first, struck-through -->
              <span class="price-original" *ngIf="getOriginalPrice(item)">
                <span class="price-currency">Rs.</span>
                <span class="price-value">{{ getOriginalPrice(item) }}</span>
              </span>

              <!-- Discounted / current price -->
              <span class="price-current">
                <span class="price-currency">Rs.</span>
                <span class="price-value">{{ getDisplayPrice(item) }}</span>
              </span>

              <span class="price-discount" *ngIf="getDiscountPercentage(item) > 0">
                ({{ getDiscountPercentage(item) }}% OFF)
              </span>
            </div>
          </div>
        </article>
      </ng-container>
    </div>

        <div class="empty-state" *ngIf="categoryListArrayNew?.length <= 0">
          <span>No products found</span>
    </div>

    <div class="pagination-section" *ngIf="totalItems > itemPerPage">
      <div class="pagination-controls">
        <button
          class="pagination-btn prev-btn"
          [disabled]="currentPage === 1"
          (click)="goToPage(currentPage - 1)"
          [class.disabled]="currentPage === 1"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <button
          *ngFor="let page of getPageNumbers()"
          class="pagination-btn page-btn"
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>

        <button
          class="pagination-btn next-btn"
          [disabled]="currentPage === getTotalPages()"
          (click)="goToPage(currentPage + 1)"
          [class.disabled]="currentPage === getTotalPages()"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</section>
